module.exports = __webpack_public_path__ + "0f6e6187b80597b05c6b54deb3b8749d.dcm";